import { RefObject } from 'react';
import { HotkeyCallback, Keys, Options, useHotkeys } from 'react-hotkeys-hook';
import { HotkeysEvent, OptionsOrDependencyArray } from 'react-hotkeys-hook/dist/types';

type AsyncHotkeyCallback = (keyboardEvent: KeyboardEvent, hotkeysEvent: HotkeysEvent) => Promise<void>;

export const useCustomHotkeys = (
  keys: Keys,
  callback: HotkeyCallback | AsyncHotkeyCallback,
  options?: Options,
  dependencies?: OptionsOrDependencyArray
): RefObject<HTMLElement | null> => {
  const customKeyTest = (e: KeyboardEvent): boolean => {
    const targetElement = e.target && (e.target as HTMLInputElement);
    return (
      targetElement?.tagName.toLowerCase() === 'textarea' ||
      (targetElement?.tagName.toLowerCase() === 'input' && targetElement.type !== 'radio' && targetElement.type !== 'checkbox')
    );
  };

  const extendedOptions = {
    ...(options ?? {}),
    enableOnFormTags: true,
    ignoreEventWhen: customKeyTest,
  };

  return useHotkeys(
    keys,
    (e, h) => {
      void callback(e, h);
    },
    extendedOptions,
    dependencies
  );
};
